export type ScrollToTestIdOptions = {
  offset?: number;
  behavior?: ScrollBehavior;
  focus?: boolean;
};

export function scrollToTestId(
  testId: string,
  options: ScrollToTestIdOptions = {},
): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const { offset = 96, behavior = 'smooth', focus = false } = options;

  const escapedTestId =
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
      ? CSS.escape(testId)
      : testId.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const element = document.querySelector<HTMLElement>(
    `[data-testid="${escapedTestId}"]`,
  );

  if (!element) return false;

  const top = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top,
    behavior,
  });

  if (focus) {
    window.setTimeout(
      () => {
        const hadTabIndex = element.hasAttribute('tabindex');

        if (!hadTabIndex) {
          element.setAttribute('tabindex', '-1');
        }

        element.focus({ preventScroll: true });
      },
      behavior === 'smooth' ? 350 : 0,
    );
  }

  return true;
}
